import { render, staticRenderFns } from "./picker.vue?vue&type=template&id=ed4a8450&scoped=true&"
import script from "./picker.vue?vue&type=script&lang=js&"
export * from "./picker.vue?vue&type=script&lang=js&"
import style0 from "./picker.vue?vue&type=style&index=0&id=ed4a8450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4a8450",
  null
  
)

export default component.exports